import request from 'superagent';

const http = {
  post: (url, data) => {
    const postUrl = API.ajaxurl + '?action=re_' + url;
    if (API.post_id) {
      data.post_id = API.post_id;
    }
    if (API.builder_nonce) {
      data.builder_nonce = API.builder_nonce;
    }
    let param = '';
    if (data) {
      param = jQuery.param(data);
    }
    return request.post(postUrl).send(param).set('Accept', 'application/x-www-form-urlencoded');
  },
};

export default http;



/** WEBPACK FOOTER **
 ** ./assets/src/frontend/helper/ajax.js
 **/